var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightchevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.09 0.09C0.15 0.03 0.223333 0 0.31 0C0.396667 0 0.47 0.03 0.53 0.09L5.44 5L0.53 9.91C0.47 9.97 0.396667 10 0.31 10C0.223333 10 0.15 9.97 0.09 9.91C0.03 9.85 0 9.77667 0 9.69C0 9.60333 0.03 9.53 0.09 9.47L4.56 5L0.09 0.53C0.03 0.47 0 0.396666 0 0.31C0 0.223333 0.03 0.15 0.09 0.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightchevron);
export default __webpack_public_path__ + "static/media/rightchevron.7371ddc3b9fe9de021ca0ee6532f29f4.svg";
export { ForwardRef as ReactComponent };